<template>
  <div class="app-container" >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="月度核算" name="one" style="">
        <yueDuHeSuan v-if="activeName=='one'" ref="yueDuHeSuan" @switchToDetails="handleSwitchToDetails"></yueDuHeSuan>
      </el-tab-pane>
      <el-tab-pane label="核算明细" name="two">
        <hesuanDetails v-if="activeName=='two'" ref="hesuanDetails" :detailId="detailId" :yearMonth="yearMonth"></hesuanDetails>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import yueDuHeSuan from '@/views/newTMS/costExpense/danchehesuan/yueDuHeSuan.vue'
import hesuanDetails from '@/views/newTMS/costExpense/danchehesuan/hesuanDetails.vue'
export default {
  components: {
    yueDuHeSuan, hesuanDetails
  },
  data () {
    return {
      activeName: 'one',
      detailId: null,
      yearMonth: ''
    }
  },
  created () {
    // if (this.$route.query.ZDFlag) {
    //   this.activeName = 'two'
    // } else {
    //   this.activeName = 'one'
    // }
  },
  methods: {
    handleSwitchToDetails (params) {
      this.detailId = params && params.id ? params.id : null
      this.yearMonth = params && params.yearMonth ? params.yearMonth : ''
      this.activeName = 'two'
    },
    handleClick (tab) {
      if (tab.name === 'two' && !this.detailId && this.$refs.hesuanDetails) {
        this.$refs.hesuanDetails.loadDefaultData()
      }
      if (tab.name === 'one') {
        this.detailId = null
        this.yearMonth = ''
      }
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin: 0;
}
</style>
